export default "__VITE_ASSET__U4sspHr$fzLvD1k5cV0yzw__";